// Determine if we're in production environment
// Check multiple sources to determine production status
const checkProduction = () => {
  // Primary check: NODE_ENV (set at build time)
  if (process.env.NODE_ENV === 'production') {
    return true;
  }
  
  // Secondary check: REACT_APP_ENV environment variable
  if (process.env.REACT_APP_ENV === 'production') {
    return true;
  }
  
  // Tertiary check: Hostname (runtime check, only if window is available)
  if (typeof window !== 'undefined' && window.location) {
    const hostname = window.location.hostname;
    if (hostname !== 'localhost' && 
        !hostname.includes('127.0.0.1') && 
        !hostname.includes('0.0.0.0')) {
      return true;
    }
  }
  
  return false;
};

const isProduction = checkProduction();

// Production API URLs
const PRODUCTION_API_URL = 'https://admin-api.explosionsocial.com/api';
const PRODUCTION_SERVER_URL = 'https://admin-api.explosionsocial.com';

// Development API URLs (defaults)
const DEVELOPMENT_API_URL = 'http://localhost:8080/api';
const DEVELOPMENT_SERVER_URL = 'http://localhost:8080';

// Determine URLs based on environment or explicit env vars
const apiUrl = process.env.REACT_APP_API_URL || 
               (isProduction ? PRODUCTION_API_URL : DEVELOPMENT_API_URL);

const serverUrl = process.env.REACT_APP_SERVER_URL || 
                  (isProduction ? PRODUCTION_SERVER_URL : DEVELOPMENT_SERVER_URL);

export const config = {
  // API URL for API calls (with /api suffix)
  API_URL: apiUrl,
  
  // Server URL for redirects (without /api suffix)
  SERVER_URL: serverUrl,
  
  APP_PORT: process.env.PORT || 3001,
  
  // Environment info (for debugging)
  IS_PRODUCTION: isProduction,
  ENVIRONMENT: isProduction ? 'production' : 'development'
};

// Log configuration for debugging (only in development)
if (process.env.NODE_ENV === 'development' || !isProduction) {
  console.log('🔧 Configuration:', {
    environment: config.ENVIRONMENT,
    isProduction: config.IS_PRODUCTION,
    apiUrl: config.API_URL,
    serverUrl: config.SERVER_URL,
    nodeEnv: process.env.NODE_ENV,
    reactAppEnv: process.env.REACT_APP_ENV,
    hostname: typeof window !== 'undefined' ? window.location.hostname : 'N/A',
    overrides: {
      apiUrl: process.env.REACT_APP_API_URL || 'none',
      serverUrl: process.env.REACT_APP_SERVER_URL || 'none'
    }
  });
}
